module.exports = __webpack_public_path__ + "img/zhuanpan_bottom.31618d2f.png";